"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _logger = require("@insided/shared/services/logger");

var _header = _interopRequireDefault(require("../header"));

var _IdeationList = _interopRequireDefault(require("./IdeationList"));

var _IdeationAddEdit = _interopRequireDefault(require("./IdeationAddEdit"));

var _reactModal = _interopRequireDefault(require("../../components/reactModal"));

var _ConfirmationModal = _interopRequireDefault(require("../ui-components/ConfirmationModal"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function isIdeation(whatever) {
  return !!whatever;
}

var IdeationContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeationContainer, _Component);

  var _super = _createSuper(IdeationContainer);

  function IdeationContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, IdeationContainer);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "endpoints", void 0);
    _this.state = {
      list: [],
      newIdeation: {
        name: '',
        bgColor: '#000000',
        textColor: '#ffffff'
      },
      editableIdeationData: null,
      showModal: false,
      showConfirmation: false,
      isLoading: false,
      showError: false,
      deleteItem: null,
      messageType: null,
      message: ''
    };
    _this.endpoints = {
      getIdeations: '/settings/ideation/_getstatuses',
      setIdeation: '/settings/ideation/updateStatus',
      deleteIdeation: '/settings/ideation/deleteStatus'
    };
    _this.enableModal = _this.enableModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveIdeation = _this.saveIdeation.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateIdeation = _this.updateIdeation.bind((0, _assertThisInitialized2.default)(_this));
    _this.shouldDeleteIdeation = _this.shouldDeleteIdeation.bind((0, _assertThisInitialized2.default)(_this));
    _this.deleteIdeation = _this.deleteIdeation.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(IdeationContainer, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _yield$axios$get, data;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _axios.default.get(this.endpoints.getIdeations);

              case 2:
                _yield$axios$get = _context.sent;
                data = _yield$axios$get.data;

                if (data.length) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                data.forEach(function (item) {
                  item.bgColor = "#".concat(item.bgColor);
                  item.textColor = "#".concat(item.textColor);
                });
                this.setState({
                  list: data,
                  newIdeation: _objectSpread(_objectSpread({}, this.state.newIdeation), {}, {
                    bgColor: data[0].bgColor
                  })
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "saveIdeation",
    value: function () {
      var _saveIdeation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var newData, _newData, _yield$axios$post, data, updatedList;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newData = this.state.editableIdeationData;

                if (isIdeation(this.state.editableIdeationData)) {
                  newData = _objectSpread(_objectSpread({}, this.state.editableIdeationData), {}, {
                    bgColor: this.state.editableIdeationData.bgColor.substr(1),
                    textColor: this.state.editableIdeationData.textColor.substr(1)
                  });
                }

                this.setState({
                  isLoading: true,
                  showError: false,
                  messageType: null,
                  message: ''
                });
                _context2.prev = 3;
                _context2.next = 6;
                return _axios.default.post(this.endpoints.setIdeation, _objectSpread({}, newData));

              case 6:
                _yield$axios$post = _context2.sent;
                data = _yield$axios$post.data;
                updatedList = this.state.list;

                if (this.state.editableIdeationData && typeof this.state.editableIdeationData.index === 'number') {
                  updatedList[this.state.editableIdeationData.index] = _objectSpread(_objectSpread({}, this.state.editableIdeationData), data);
                }

                this.setState({
                  list: updatedList,
                  showModal: false,
                  isLoading: false,
                  message: (_newData = newData) !== null && _newData !== void 0 && _newData.id ? 'All changes saved!' : 'A new ideation is added successfully!',
                  messageType: 'success'
                });
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](3);

                _logger.logger.error(_context2.t0, {
                  component: 'IdeationContainer',
                  action: 'saveIdeation'
                });

                this.setState({
                  isLoading: false,
                  showError: true
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 13]]);
      }));

      function saveIdeation() {
        return _saveIdeation.apply(this, arguments);
      }

      return saveIdeation;
    }()
  }, {
    key: "enableModal",
    value: function enableModal(item, idx) {
      this.setState({
        editableIdeationData: _objectSpread(_objectSpread({}, item), {}, {
          index: idx
        }),
        showModal: true,
        message: '',
        messageType: null
      });
    }
  }, {
    key: "updateIdeation",
    value: function updateIdeation(newData) {
      this.setState({
        editableIdeationData: newData
      });
    }
  }, {
    key: "shouldDeleteIdeation",
    value: function shouldDeleteIdeation(idx) {
      this.setState({
        showConfirmation: true,
        deleteItem: idx
      });
    }
  }, {
    key: "deleteIdeation",
    value: function () {
      var _deleteIdeation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var idx, updatedList;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof this.state.deleteItem !== 'number')) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                this.setState({
                  isLoading: true,
                  showError: false,
                  messageType: null,
                  message: ''
                });
                idx = this.state.deleteItem;
                updatedList = this.state.list.slice();
                updatedList.splice(idx, 1);

                if (!(idx <= this.state.list.length)) {
                  _context3.next = 19;
                  break;
                }

                _context3.prev = 7;
                _context3.next = 10;
                return _axios.default.post(this.endpoints.deleteIdeation, {
                  id: this.state.list[idx].id
                });

              case 10:
                this.setState({
                  list: updatedList,
                  showConfirmation: false,
                  isLoading: false,
                  message: 'An ideation status is deleted',
                  messageType: 'success'
                });
                _context3.next = 17;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](7);

                _logger.logger.error(_context3.t0, {
                  component: 'IdeationContainer',
                  action: 'deleteIdeation'
                });

                this.setState({
                  isLoading: false,
                  showError: true
                });

              case 17:
                _context3.next = 20;
                break;

              case 19:
                this.setState({
                  list: updatedList,
                  showConfirmation: false
                });

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 13]]);
      }));

      function deleteIdeation() {
        return _deleteIdeation.apply(this, arguments);
      }

      return deleteIdeation;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          list = _this$state.list,
          showModal = _this$state.showModal,
          editableIdeationData = _this$state.editableIdeationData,
          isLoading = _this$state.isLoading,
          showError = _this$state.showError,
          showConfirmation = _this$state.showConfirmation,
          deleteItem = _this$state.deleteItem,
          messageType = _this$state.messageType,
          message = _this$state.message;
      var colors = list.reduce(function (allColors, item) {
        if (item.bgColor && !allColors.includes(item.bgColor)) {
          allColors.push(item.bgColor);
        }

        return allColors;
      }, []);
      return (0, _preact.h)("div", {
        className: "ideation-page_container"
      }, (0, _preact.h)(_header.default, {
        title: "Ideation Status",
        disableCancelButton: true,
        disableSaveButton: true
      }), messageType ? (0, _preact.h)(_AlertComponent.default, {
        message: message,
        messageType: messageType,
        isVisibleFor: 3000
      }) : null, (0, _preact.h)(_IdeationList.default, {
        deleteCallback: this.shouldDeleteIdeation,
        list: list,
        colors: colors,
        openEditIdeationModal: this.enableModal
      }), (0, _preact.h)("div", {
        className: "ideation-add-trigger-button"
      }, (0, _preact.h)("button", {
        className: "btn btn-primary",
        onClick: function onClick() {
          return _this2.enableModal(_this2.state.newIdeation, list.length);
        }
      }, "Add new status")), (0, _preact.h)(_reactModal.default, {
        isOpen: showModal,
        onClose: function onClose() {
          return _this2.setState({
            showModal: false,
            showError: false
          });
        }
      }, (0, _preact.h)(_IdeationAddEdit.default, {
        title: editableIdeationData && editableIdeationData.index === list.length ? 'Add new status' : 'Edit status',
        data: editableIdeationData,
        colors: colors,
        onCallback: this.updateIdeation,
        cancelCallback: function cancelCallback() {
          _this2.setState({
            showModal: false,
            showError: false
          });
        },
        isLoading: isLoading,
        showError: showError,
        saveCallback: this.saveIdeation
      })), (0, _preact.h)(_ConfirmationModal.default, {
        isLoading: isLoading,
        showError: showError,
        enableModal: showConfirmation,
        title: deleteItem ? "Delete this ideation status '".concat(list[deleteItem] && list[deleteItem].name, "'?") : '',
        message: "All ideas with this status will lose their status.",
        onClose: function onClose() {
          _this2.setState({
            showConfirmation: false,
            showError: false
          });
        },
        buttons: [{
          text: 'Delete',
          callback: this.deleteIdeation,
          class: 'btn btn-danger',
          showLoading: true
        }, {
          text: 'Cancel',
          callback: function callback() {
            _this2.setState({
              showConfirmation: false,
              showError: false
            });
          },
          class: 'btn btn-default',
          showLoading: false
        }]
      }));
    }
  }]);
  return IdeationContainer;
}(_preact.Component);

var _default = IdeationContainer;
exports.default = _default;